import Card from './card.vue';
export default Card;



// WEBPACK FOOTER //
// ./src/components/card/index.js